import React from "react";

export const ModalWindow: React.FC<{}> = ({ children }) => {
    return (
        <div className='bg-gray-800 bg-opacity-50 w-screen h-screen fixed z-50 inset-0 overflow-y-scroll md:p-8 md:pb-16' id="modalWindow">
            <div className='flex md:items-center min-h-full'>
                <div className='relative mx-auto w-full max-w-5xl flex'>
                    <div className='w-full h-full md:h-5/6 bg-white relative md:rounded-md md:shadow-lg overflow-hidden'>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}
